import React from 'react';
import PropTypes from 'prop-types';
import {sanitizeContent} from 'js/shared/security';

const MegaMenuImageBlock = ({
  title,
  alt,
  url,
  imageTitle,
  imageSubTitle,
  link,
}) => {

  const onClick = (e) => {
    if (link) {
      window.location.href = link;
    } else {
      e.preventDefault();
      return false;
    }
  };

  return (
    <a
      className="megamenu__image"
      onClick={onClick}
      href={link || '#'}
    >
      <img
        src={url}
        width="220"
        height="220"
        alt={alt}
        title={title}
        loading="lazy"
      />
      <div className="megamenu__image-subtitle">{imageSubTitle}</div>
      <div
        className="megamenu__image-title"
        dangerouslySetInnerHTML={{ __html: sanitizeContent(imageTitle) }}
      />
    </a>
  );
};

MegaMenuImageBlock.propTypes = {
  title: PropTypes.string,
  alt: PropTypes.string,
  url: PropTypes.string.isRequired,
  classStyle: PropTypes.string,
  imagesBlock: PropTypes.object,
  imageTitle: PropTypes.string,
  imageSubTitle: PropTypes.string,
  link: PropTypes.string,
};

export default MegaMenuImageBlock;
